import React from 'react';
import PropTypes from 'prop-types';

import sentry from '../../../../utils/sentry';

const { captureException } = sentry();

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    captureException(error);
  }

  render() {
    if (this.state.error) {
      return <p style={{ backgroundColor: 'red' }}>{this.state.error}</p>;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default (Component, componentProps = {}, children) => {
  const wrappedComponent = children ? (
    <Component {...componentProps}>{children}</Component>
  ) : (
    <Component {...componentProps} />
  );

  return (
    <ErrorBoundary key={`error-boundary-${componentProps.key}`}>{wrappedComponent}</ErrorBoundary>
  );
};
